import { Controller } from "@hotwired/stimulus";
import { handlePartialInvoiceGenerationFromQuoteResponse } from "../../sales_invoices/utils";

export default class extends Controller {
  static values = {
    modalId: String,
  };

  onFormSubmit(event) {
    const payload = event.detail[0];
    handlePartialInvoiceGenerationFromQuoteResponse(payload, this.modalIdValue);
  }
}
